export enum NotificationType {
  Success,
  Warning,
  Error,
  info,
}

export type Notification = {
  active: boolean;
  message: string;
  color: string;
  timeout: number;
  type: NotificationType;
};
